import React, { createContext } from 'react';

export const ScreenContext = createContext({});
